module.exports = __webpack_public_path__ + "media/img/gam-card-88816db7.svg";